module.exports = __webpack_public_path__ + "static/media/arrow_history.7d04bcad.svg";